<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'home' }">{{
                $t("inicio")
              }}</router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">
              {{ $t("informes") }}
            </li>
          </ol>
        </nav>
      </div>
      <div class="col-md-4" v-if="grupoVentas">
        <h2><i class="fas fa-chart-area"></i> {{ $t("ventas") }}</h2>
        <card>
          <div class="content-card">
            <ul class="list-files">
              <!--<router-link :to="{name:'ventas-dispositivo'}">
                            <li>Informe Personalizado</li>
                            </router-link>-->
              <router-link
                v-if="ventasNegocio"
                :to="{ name: 'ventas-negocios' }"
              >
                <li>
                  {{ $t("ventasPorNegocio") }}<br />
                  <span class="text-muted"
                    >{{ $t("detalleDe") }}
                    <strong>{{ $t("cierresDeCaja") }}</strong></span
                  >
                </li>
              </router-link>

              <router-link
                v-if="rangoHorarios"
                :to="{ name: 'ventas-negocios-zona-horaria' }"
              >
                <li>
                  {{ $t("ventasPorRangosHorarios") }}<br />
                  <span class="text-muted"
                    >{{ $t("detalleDe") }}
                    <strong>{{ $t("cierresDeCaja") }}</strong
                    >{{ $t("porRangosHorarios") }}</span
                  >
                </li>
              </router-link>

              <router-link
                v-if="ventasComensales && soloRetail"
                :to="{ name: 'ventas-comensales' }"
              >
                <li>
                  {{ $t("ventasPorComensales") }}<br />
                  <span class="text-muted"
                    >{{ $t("detalleDeVentasSegun")
                    }}<strong>{{ $t("comensalesMinuscula") }}</strong></span
                  >
                </li>
              </router-link>

              <router-link
                v-if="rangoHorarios && soloRetail"
                :to="{ name: 'ventas-negocios-rango-mesas' }"
              >
                <li>
                  {{ $t("ventasPorRangoDeMesas") }}<br />
                  <span class="text-muted"
                    >{{ $t("detalleDe") }}
                    <strong>{{ $t("ventasMinusculas") }}</strong
                    >{{ $t("porRangoDeMesas") }}</span
                  >
                </li>
              </router-link>

              <router-link
                v-if="facturasSimplificadas"
                :to="{ name: 'facturacion-general' }"
              >
                <li>
                  {{ $t("facturacionGeneral") }}<br />
                  <span class="text-muted"
                    >{{ $t("desgloseDe")
                    }}<strong>{{ $t("facturasMinusculas") }}</strong>
                    {{ $t("deTodasLasSeries") }}
                  </span>
                </li>
              </router-link>
              
              <router-link
                v-if="facturasSimplificadas"
                :to="{ name: 'tickets' }"
              >
                <li>
                  {{ $t("facturasSimplificadas") }}<br />
                  <span class="text-muted"
                    >{{ $t("desgloseDe")
                    }}<strong>{{ $t("ticketsCobrados") }}</strong>
                    {{ $t("segunTipoDeIVA") }}</span
                  >
                </li>
              </router-link>
              <router-link
                v-if="facturasNominativas"
                :to="{ name: 'facturas-emitidas' }"
              >
                <li>
                  {{ $t("facturasEmitidas") }}<br />
                  <span class="text-muted"
                    >{{ $t("detalleDe")
                    }}<strong>{{ $t("facturasEmitidasMinuscula") }}</strong
                    >{{ $t("aClientes") }}</span
                  >
                </li>
              </router-link>
              <router-link
                v-if="facturasNominativas"
                :to="{ name: 'facturas-emitidas-qr' }"
              >
                <li>
                  {{ $t("facturasEmitidas") }} QR<br />
                  <span class="text-muted"
                    >{{ $t("detalleDe")
                    }}<strong>{{ $t("facturasEmitidasMinuscula") }} a través de Numier FACTURA QR</strong
                    >{{ $t("aClientes") }}</span
                  >
                </li>
              </router-link>
              <router-link
                v-if="ventasRectificadas"
                :to="{ name: 'ventas-rectificadas' }"
              >
                <li>
                  {{ $t("cuentasRectificadas") }}<br />
                  <span class="text-muted"
                    >{{ $t("desgloseDe")
                    }}<strong>{{ $t("cuentasRectificadasMinusculas") }}</strong
                    >{{ $t("delNegocio") }}</span
                  >
                </li>
              </router-link>
              <router-link
                v-if="ventasAnuladas"
                :to="{ name: 'ventas-anuladas' }"
              >
                <li>
                  {{ $t("cuentasAnuladas") }}<br />
                  <span class="text-muted"
                    >{{ $t("desgloseDe")
                    }}<strong>{{ $t("cuentasAnuladasMinusculas") }}</strong
                    >{{ $t("delNegocio") }}</span
                  >
                </li>
              </router-link>
       

              <!-- <router-link
                :to="{ name: 'informe-pedidos-detalle' }"
              >
                <li>
                  {{ $t("informePedidosDetalle") }}<br />
                  <span class="text-muted"
                    >{{ $t("detalleDe")
                    }}<strong>{{ $t("informePedidos") }}</strong
                    ></span
                  >
                </li>
              </router-link> -->

              <router-link v-if="formasPago" :to="{ name: 'formas-pago' }">
                <li>
                  {{ $t("formasDePago") }}<br />
                  <span class="text-muted"
                    >{{ $t("desgloseDeVentasSegun")
                    }}<strong>{{ $t("formasDePagoMinusculas") }}</strong></span
                  >
                </li>
              </router-link>

              <router-link
                v-if="agencias"
                :to="{ name: 'estadistica-agencia' }"
              >
                <li>
                  {{ $t("agencias") }}<br />
                  <span class="text-muted"
                    >{{ $t("desgloseDeVentasSegun")
                    }}<strong>{{ $t("agenciasMinusculas") }}</strong></span
                  >
                </li>
              </router-link>

              <router-link
                v-if="cuentasAparcadas"
                :to="{ name: 'cuentas-aparcadas' }"
              >
                <li>
                  {{ $t("cuentasAparcadas") }}<br />
                  <span class="text-muted"
                    >{{ $t("detalleDe")
                    }}<strong>{{ $t("cuentasACredito") }}</strong></span
                  >
                </li>
              </router-link>

              <router-link
                v-if="cierreCajas"
                :to="{ name: 'desgloses-impuestos' }"
              >
                <li>
                  {{ $t("desglosesImpuestos") }}<br />
                  <span class="text-muted"
                    >{{ $t("sumatorioDe")
                    }}<strong>{{ $t("impuestos") }}</strong
                    >{{ $t("porFechas") }}</span
                  >
                </li>
              </router-link>
              <router-link
                v-if="facturasNominativas"
                :to="{ name: 'retiradas' }"
              >
                <li>
                  {{ $t("retiradas") }}<br />
                  <span class="text-muted"
                    >{{ $t("desgloseDe")
                    }}<strong>{{ $t("retiradasMinusculas") }}</strong
                    >{{ $t("delNegocio") }}</span
                  >
                </li>
              </router-link>
              <!--<router-link v-if="ventaProducto" :to="{name:'cierres-caja'}">-->
              <!--<li>Cierre cajas</li>-->
              <!--</router-link>-->
            </ul>
          </div>
        </card>
      </div>

      <div class="col-md-4" v-if="grupoProducto">
        <h2><i class="fa fa-th-large"></i> {{ $t("productos") }}</h2>

        <card>
          <div class="content-card">
            <ul class="list-files">
              <router-link
                v-if="ventasProductos"
                :to="{ name: 'ventas-productos' }"
              >
                <li>
                  {{ $t("ventaDeProductosPorNegocio") }}<br />
                  <span class="text-muted"
                    >{{ $t("rankingDe") }}
                    <strong>{{
                      $t("ventasDeProductosMinusculas") 
                    }}</strong></span
                  >
                </li>
              </router-link>
              <router-link
                v-if="costeProductos"
                :to="{ name: 'ventas-avanzadas-productos' }"
              >
                <li>
                  {{ $t("costeDeProductos") }}<br />
                  <span class="text-muted"
                    ><strong>{{ $t("margenDeCostes") }}</strong>
                    {{ $t("segunVentasPorRangoDeFecha") }}</span
                  >
                </li>
              </router-link>
              <router-link
                v-if="costeProductos"
                :to="{ name: 'ventas-avanzadas-productos-agencias' }"
              >
                <li>
                  {{ $t("costeDeProductosPorAgencias") }}<br />
                  <span class="text-muted"
                    ><strong>{{ $t("margenDeCostes") }}</strong>
                    {{ $t("segunVentasPorRangoDeFecha") }} {{ $t("agrupadoPorAgencias") }}</span
                  >
                </li>
              </router-link>
              <router-link
                v-if="historicoDeProductos"
                :to="{ name: 'historico-productos' }"
              >
                <li>
                  {{ $t("historicoDeProducto") }}<br />
                  <span class="text-muted"
                    ><strong>{{ $t("historicoDeProductos") }}</strong>
                    {{ $t("segunVentasPorRangoDeFecha") }}</span
                  >
                </li>
              </router-link>
              <router-link
                v-if="ventasTotalProductos"
                :to="{ name: 'ventas-total-productos' }"
              >
                <li>
                  {{ $t("ventasDeProductosGlobal") }}<br />
                  <span class="text-muted"
                    >{{ $t("rankingAgrupadoDe") }}
                    <strong>{{ $t("ventasDeProductosMinusculas") }}</strong>
                    {{ $t("enTodosLosNegocios") }}</span
                  >
                </li>
              </router-link>
              <router-link
                v-if="ventasCategorias"
                :to="{ name: 'ventas-categorias' }"
              >
                <li>
                  {{ $t("ventasDeCategoriasPorNegocio") }}<br />
                  <span class="text-muted"
                    >{{ $t("agrupacionDe")
                    }}<strong> {{ $t("ventasDeCategoriasMinusculas") }}</strong>
                    {{ $t("deProductos") }}</span
                  >
                </li>
              </router-link>
              <router-link
                v-if="ventasProductos"
                :to="{ name: 'ventas-productos-por-rango-de-mesas' }"
              >
                <li>
                  {{ $t("ventaDeProductosPorRangoDeMesas") }}<br />
                  <span class="text-muted"
                    >{{ $t("rankingDe") }}
                    <strong>{{
                      $t("ventasDeProductosMinusculas") 
                    }}</strong>
                    {{ $t("filtradoPorRangoDeMesas") }}
                    </span
                  >
                </li>
              </router-link>
              <router-link v-if="invitaciones" :to="{ name: 'invitaciones' }">
                <li>
                  {{ $t("invitaciones") }}<br />
                  <span class="text-muted"
                    >{{ $t("desgloseDe")
                    }}<strong> {{ $t("invitacionesMinusculas") }}</strong>
                    {{ $t("deProductos") }}</span
                  >
                </li>
              </router-link>
            </ul>
          </div>
        </card>
      </div>

      <div class="col-md-4" v-if="gastosMateriaPrima">
        <div class="">
          <h2><i class="fa fa-th"></i> {{ $t("materiasPrimas") }}</h2>
          <card>
            <div class="content-card">
              <ul class="list-files">
                <router-link
                  v-if="ventasProductos"
                  :to="{ name: 'ventas-materias-primas-negocios' }"
                >
                  <li>
                    {{ $t("ventasPorMateriasPrimas") }}<br />
                    <span class="text-muted"
                      >{{ $t("rankingDe") }}
                      <strong>
                        {{ $t("ventasDeMateriasPrimasMinusculas") }}</strong
                      ></span
                    >
                  </li>
                </router-link>
                <router-link
                  v-if="gastosMateriaPrima"
                  :to="{ name: 'gastos-materias-primas' }"
                >
                  <li>
                    {{ $t("gastosPorMateriasPrimas") }}<br />
                    <span class="text-muted"
                      >{{ $t("detalleDe")
                      }}<strong> {{ $t("comprasDeMateriasPrimas") }}</strong>
                      {{ $t("porRangoDeFecha") }}</span
                    >
                  </li>
                </router-link>
                <router-link
                  v-if="sectores"
                  :to="{ name: 'consultar-inventario-por-sectores' }"
                >
                  <li>
                    {{ $t("consultarInventarioPorSectores") }}<br />
                    <span class="text-muted"
                      >{{ $t("consultar")
                      }}<strong> {{ $t("invetario") }}</strong>
                      {{ $t("porSectores") }}</span
                    >
                  </li>
                </router-link>
              </ul>
            </div>
          </card>
          <!-- <div class="">  //v-if="tieneSage" :key="tieneSage" 
            <h2><i class="fa fa-th"></i> {{ $t("sage") }}</h2>
            <card>
              <div class="content-card">
                <ul class="list-files">
                  <router-link 
                    :to="{ name: 'plan-de-cuentas' }"
                  >
                    <li>
                      {{ $t("sageplancuentas") }}<br />
                      <span class="text-muted"
                        >{{ $t("detalleDe")
                        }}<strong> {{ $t("sageplancuentas") }}</strong>
                        {{ $t("porRangoDeFecha") }}</span
                      >
                    </li>
                  </router-link>
                  <router-link 
                    :to="{ name: 'sage-clientes' }"
                  >
                    <li>
                      {{ $t("sageclientes") }}<br />
                      <span class="text-muted"
                        >{{ $t("detalleDe")
                        }}<strong> {{ $t("sageclientes") }}</strong>
                        {{ $t("porRangoDeFecha") }}</span
                      >
                    </li>
                  </router-link>
                  <router-link 
                    :to="{ name: 'sage-efectos' }"
                  >
                    <li>
                      {{ $t("sageefectos") }}<br />
                      <span class="text-muted"
                        >{{ $t("detalleDe")
                        }}<strong> {{ $t("sageefectos") }}</strong>
                        {{ $t("porRangoDeFecha") }}</span
                      >
                    </li>
                  </router-link>
                  <router-link 
                    :to="{ name: 'asiento-contable' }"
                  >
                    <li>
                      {{ $t("sageasientos") }}<br />
                      <span class="text-muted"
                        >{{ $t("detalleDe")
                        }}<strong> {{ $t("sageasientos") }}</strong>
                        {{ $t("porRangoDeFecha") }}</span
                      >
                    </li>
                  </router-link> 
                </ul>
              </div>
            </card>
          </div> -->
        </div>
      </div>

      <div class="col-md-4" v-if="grupoProveedores">
        <h2><i class="fa fa-briefcase"></i> {{ $t("proveedores") }}</h2>
        <card>
          <div class="content-card">
            <ul class="list-files">
              <router-link
                v-if="gastosProveedor"
                :to="{ name: 'gastos-proveedor' }"
              >
                <li>
                  {{ $t("gastosDeProveedores") }}<br />
                  <span class="text-muted"
                    >{{ $t("detalleDe")
                    }}<strong> {{ $t("comprasAProveedores") }}</strong>
                    {{ $t("porRangoDeFecha") }}</span
                  >
                </li>
              </router-link>
              <router-link
                v-if="gastosProveedoresUnidos"
                :to="{ name: 'gastos-general-proveedor' }"
              >
                <li>
                  {{ $t("gastosPorProveedor") }}<br />
                  <span class="text-muted"
                    >{{ $t("detalleDe")
                    }}<strong> {{ $t("comprasAUnProveedor") }}</strong>
                    {{ $t("porRangoDeFechaEn")
                    }}<strong> {{ $t("todosLosNegocios") }}</strong></span
                  >
                </li>
              </router-link>
              <router-link
                v-if="gastosEtiquetas"
                :to="{ name: 'gastos-etiquetas' }"
              >
                <li>
                  {{ $t("gastosPorEtiquetas") }}
                  <br />
                  <span class="text-muted"
                    >{{ $t("detalleDe")
                    }}<strong> {{ $t("comprasAgrupadasPorEtiquetas") }}</strong>
                    {{ $t("porRangoDeFecha") }}</span
                  >
                </li>
              </router-link>
            </ul>
          </div>
        </card>
      </div>

      <div class="col-md-4" v-if="grupoCasa">
        <h2><i class="fa fa-home"></i> {{ $t("casas") }}</h2>
        <card>
          <div class="content-card">
            <ul class="list-files">
              <router-link
                v-if="gastosCasas"
                :to="{ name: 'compras-negocios' }"
              >
                <li>
                  {{ $t("gastosDeCasas") }}<br />
                  <span class="text-muted"
                    >{{ $t("detalleDe")
                    }}<strong>{{ $t("comprasAFabricantes") }}</strong>
                    {{ $t("porRangoDeFecha") }}</span
                  >
                </li>
              </router-link>
              <router-link v-if="gastoCasas" :to="{ name: 'compras-casas' }">
                <li>
                  {{ $t("gastosPorCasa") }}<br />
                  <span class="text-muted"
                    >{{ $t("detalleDe")
                    }}<strong>{{ $t("comprasAUnFabricante") }}</strong>
                    {{ $t("porRangoDeFecha") }}</span
                  >
                </li>
              </router-link>
              <!--<router-link :to="{name:'gastos-casas'}">-->
              <!--<li>Gastos por casas</li>-->
              <!--</router-link>-->
            </ul>
          </div>
        </card>
      </div>

      <div class="col-md-4" v-if="grupoOperario">
        <h2><i class="fa fa-male"></i> {{ $t("operarios") }}</h2>
        <card>
          <div class="content-card">
            <ul class="list-files">
              <router-link
                v-if="ventasOperarios"
                :to="{ name: 'ventas-operarios' }"
              >
                <li>
                  {{ $t("ventasPorOperarios") }}<br />
                  <span class="text-muted"
                    >{{ $t("ranking")
                    }}<strong> de cuentas cobradas por operario</strong>
                    {{ $t("porRangoDeFecha") }}</span
                  >
                </li>
              </router-link>

              <router-link
                v-if="turnosOperarios"
                :to="{ name: 'turnos-operarios' }"
              >
                <li>
                  {{ $t("turnosOperarios") }}<br />
                  <span class="text-muted"
                    >{{ $t("detallesDe") }}<strong> {{ $t("ventasPorOperarios") }}</strong>
                    {{ $t("porRangoDeFecha") }}</span
                  >
                </li>
              </router-link>

              <router-link
                v-if="aperturasOperarios"
                :to="{ name: 'aperturas-operarios' }"
              >
                <li>
                  {{ $t("aperturasPorOperarios") }}<br />
                  <span class="text-muted"
                    >{{ $t("ranking") }}<strong> de cuentas abiertas por operario</strong>
                    {{ $t("porRangoDeFecha") }}</span
                  >
                </li>
              </router-link>
              <router-link
                :to="{ name: 'incidencias-operarios' }"
              >
                <li>
               {{ $t("incidenciaOperario") }}<br />
                  <span class="text-muted"
                    >{{ $t("ranking") }}<strong> {{$t("deIncidenciaOperario")}}</strong>
                    {{ $t("porRangoDeFecha") }}</span
                  >
                </li>
              </router-link>
              <!--<router-link v-if="registrosHorarios" :to="{name:'registros-horarios'}">
                                <li>Registros horarios<br>
                                   <span class="text-muted">Detalles de <strong> turnos</strong> por rango de fecha</span>
                                </li>
                            </router-link>
                            -->
            </ul>
          </div>
        </card>
      </div>

      <div class="col-md-4" v-if="ventasClientes">
        <h2><i class="fa fa-users"></i> {{ $t("clientes") }}</h2>
        <card>
          <div class="content-card">
            <ul class="list-files">
              <router-link
                v-if="ventasClientes"
                :to="{ name: 'ventas-clientes' }"
              >
                <li>
                  {{ $t("ventasPorClientesPlural") }}<br />
                  <span class="text-muted"
                    >{{ $t("ranking")
                    }}<strong> {{ $t("deVentasPorClientes") }}</strong>
                    {{ $t("porRangoDeFecha") }}</span
                  >
                </li>
              </router-link>

              <router-link
                v-if="ventasClientes"
                :to="{ name: 'consultar-ventas-clientes' }"
              >
                <li>
                  {{ $t("consultaDeVentasPorCliente") }}<br />
                  <span class="text-muted"
                    >{{ $t("historico")
                    }}<strong> {{ $t("deVentasPorCliente") }}</strong>
                    {{ $t("porRangoDeFecha") }}</span
                  >
                </li>
              </router-link>

              <router-link
                v-if="ventasClientes"
                :to="{ name: 'consultar-ventas-productos-cliente' }"
              >
                <li>
                  Consulta de ventas de productos por cliente<br />
                  <span class="text-muted"
                    >{{ $t("historico")
                    }}<strong> de ventas de productos por cliente</strong>
                    {{ $t("porRangoDeFecha") }}</span
                  >
                </li>
              </router-link>
              <!--<router-link v-if="ventasClientes" :to="{name:'ventas-categoria-clientes'}">
                                <li>Ventas por categoría clientes<br>
                                    <span class="text-muted">Ranking  <strong> de ventas por categoría de clientes</strong> por rango de fecha</span>
                                </li>
                            </router-link>-->
            </ul>
          </div>
        </card>
      </div>

      <div class="col-md-4" v-if="ventasClientes && soloRetail">
        <h2><i class="fa fa-utensils"></i> {{ $t("pedidos") }}</h2>
        <card>
          <div class="content-card">
            <ul class="list-files">
              <router-link
                v-if="pedidosPasarelaPago && ventasClientes && tieneStripe"
                :to="{ name: 'pedidos-pasarela-pago' }"
              >
                <li>
                  {{ $t("informeDePasarelaDePago") }}<br />
                  <span class="text-muted"
                    >{{ $t("desgloseDiarioDeLosPagosATraves") }}
                    <strong> {{ $t("pasarelaDePagoStripe") }}</strong></span
                  >
                </li>
              </router-link>
              <router-link
                v-else-if="pedidosPasarelaPago && ventasClientes && !tieneStripe"
                :to="{ name: 'pedidos-pasarela-pago-redsys' }"
              >
                <li>
                  {{ $t("informeDePasarelaDePago") }}<br />
                  <span class="text-muted"
                    >{{ $t("desgloseDiarioDeLosPagosATraves") }}
                    <strong> {{ $t("pasarelaDePago") }} Redsys</strong></span
                  >
                </li>
              </router-link>
              <router-link
                v-if="pedidosInforme && soloRetail"
                :to="{ name: 'informe-pedidos' }"
              >
                <li>
                  {{ $t("informePedidos") }}<br />
                  <span class="text-muted"
                    >{{ $t("detalleDe")
                    }}<strong>{{ $t("informePedidos") }}</strong
                    ></span
                  >
                </li>
              </router-link>

              <router-link
                v-if="pedidosVentasProductos && soloRetail"
                :to="{ name: 'informe-ventas-productos-pedidos' }"
              >
                <li>
                  {{ $t("informeDeVentasDeProductosDePedidos") }}<br />
                  <span class="text-muted"
                    >{{ $t("detalleDe")
                    }}<strong>{{ $t("informeDeVentasDeProductosDePedidos") }}</strong
                    ></span
                  >
                </li>
              </router-link>
              <router-link
              v-if="pedidosRepartidores"
                :to="{ name: 'pedidos-repartidores' }"
              >
                <li>
                  {{ $t("pedidosPorRepartidores") }}<br />
                  <span class="text-muted"
                    >{{ $t("detalleDe")
                    }}<strong>{{ $t("pedidosPorRepartidores") }}</strong
                    ></span
                  >
                </li>
              </router-link>
            </ul>
          </div>
        </card>
      </div>

      <div class="col-md-4">
        <h2><i class="fas fa-ticket-alt"></i> Vales</h2>
        <card>
          <div class="content-card">
            <ul class="list-files">
              <router-link
                :to="{ name: 'vales-clientes' }"
              >
                <li>
                  Informe de vales<br />
                  <span class="text-muted"
                    >Detalle de los vales existentes
                    <strong> {{ $t("") }}</strong></span
                  >
                </li>
              </router-link>
            </ul>
          </div>
        </card>
      </div>

    </div>
  </div>
</template>
<script>
import bus from '../../../bus'
import { mapState } from 'vuex';
export default {
  created() {
    this.$store.dispatch("setNameRoute", "Informes");
    
    bus.$on('get-business', (idBusiness) => {
      this.idBusiness = idBusiness;
      this.idsTPV = [];
      this.idTpv = 0;
      //console.log(this.idBusiness);
      this.getTpv();
    });

    this.getTpv();
    this.restrictions();
    this.getTpvsRetail();
  },
  data() {
    return {
      //PRODUCTOS
      ventasProductos: true,
      ventasTotalProductos: true,
      invitaciones: true,
      ventasCategorias: true,
      costeProductos: true,
      historicoDeProductos: true,

      //CASAS
      gastoCasas: true,
      gastosCasas: true,

      //PROVEEDOR
      gastosProveedoresUnidos: true,
      gastosProveedor: true,
      gastosEtiquetas: true,

      //MATERIA PRIMA
      gastosMateriaPrima: true,

      //SAGE
      tieneSage: true,
      //Solo RETAIL
      soloRetail: true,

      //VENTAS
      ventasNegocio: true,
      ventasComensales: true,
      facturasSimplificadas: true,
      facturasNominativas: true,
      formasPago: true,
      agencias: true,
      cuentasAparcadas: true,
      cierreCajas: true,
      ventasAnuladas: true,
      rangoHorarios: true,
      ventasRectificadas: true,

      //CLIENTES
      ventasClientes: true,

      //PEDIDOS
      pedidosRepartidores: true,
      pedidosVentasProductos: true,
      pedidosInforme: true,
      pedidosPasarelaPago: true,

      //OPERARIOS
      ventasOperarios: true,
      turnosOperarios: true,
      aperturasOperarios : true,
      registrosHorarios: true,

      grupoVentas: true,
      grupoProducto: true,
      grupoMateriaPrima: true,
      grupoProveedores: true,
      grupoCasa: true,
      grupoOperario: true,
      grupoClientes: true,
      grupoPedidos: true,
      tieneStripe: false,
      idBusiness: this.$store.getters.idBusiness,
      idTpv: 0,
    };
  },
  computed: {
    ...mapState(["listaSectores", "sectores"]),
  },
  methods: {
    getSageplancuentas(){
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(
          this.$store.getters.apiUrl + "importacion/importarSAGEPlanCuentas",
          config
        )
        .then(function (response) {
          console.log(response.data.result)
        })
    },
    getBusiness() {
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "general/getBusinessesByUser", config)
        .then(function(response) {

          vm.idBusiness = response.data.result[0].id;

          vm.getTpv();

        })
        .catch(function(error) {
          console.log(error);
        });
    },
    getTpv() {

      var config = {
          params: {
              idBusiness: this.idBusiness,
              jwt: this.$store.getters.jwt
          },
          headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
      };

      let vm = this;
      this.axios.get(this.$store.getters.apiUrl + "general/getTpvsByBusiness", config)
        .then(function (response) {

          if (response.data.response) {
            vm.idTpv = response.data.result[0].id;
            //console.log(vm.idTpv);
            vm.getPasarelaDePago();
          }

        vm.loading = false;
      })
      .catch(function (error) {
          console.log(error);
      });
    },
    /*getConfigTpvRetail() {
      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
          numConfig: 84,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.$store.dispatch("setIdBusiness", this.idBusiness);
      this.axios
        .get(this.$store.getters.apiUrl + "general/getConfigTpv", config)
        .then(function(response) {
          console.log(response);
          if (response.data.response) {
            vm.soloRetail = false;
            console.log('modo RETAIL');
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },*/
    getTpvsRetail(){
        var config = {
          params: {
              idTpv: this.idTpv,
              jwt: this.$store.getters.jwt
          },
          headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
        };
      let vm = this;
      this.axios.get(this.$store.getters.apiUrl + "tpvs/getTpvsRetail", config)
      .then(function (response) {
        if(response.data.result){
          vm.soloRetail = false;
        }else{
          vm.soloRetail = true;
        
        }
      })
    },
    getPasarelaDePago() {
      var config = {
          params: {
              idTpv: this.idTpv,
              jwt: this.$store.getters.jwt
          },
          headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
      };

      let vm = this;
      this.axios.get(this.$store.getters.apiUrl + "general/getPasarelaPagoByIdTpv", config)
        .then(function (response) {

          if (response.data.response) {
            //console.log("RESULTADO");
            //console.log(response.data.result);
            response.data.result.forEach((pasarela) => {
              if (pasarela == "S") {
                //REDSYS
                vm.tieneStripe = true;
              }
            })
          }

        vm.loading = false;
      })
      .catch(function (error) {
          console.log(error);
      });
    },
    getSageclientes(){
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(
          this.$store.getters.apiUrl + "importacion/importarSAGEClientesProveedores",
          config
        )
        .then(function (response) {
          console.log(response.data.result)
        })
    },
    getSageefectos(){
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(
          this.$store.getters.apiUrl + "importacion/importarSAGEPlanCuentas",
          config
        )
        .then(function (response) {
          console.log(response.data.result)
        })
    },
    getSageasientos(){
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(
          this.$store.getters.apiUrl + "importacion/importarSAGEAsientosContables",
          config
        )
        .then(function (response) {
          console.log(response.data.result)
        })
    },
    restrictions() {
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(
          this.$store.getters.apiUrl + "general/getRestrictionsByUser",
          config
        )
        .then(function (response) {
          if (response.data.response) {
            for (let i = 0; i < response.data.result.length; i++) {
              switch (response.data.result[i].idRestriction) {
                case 23:
                  console.log("fffff")
                  vm.ventasProductos = false;
                  break;
                case 24:
                  vm.ventasTotalProductos = false;
                  break;
                case 25:
                  vm.invitaciones = false;
                  break;
                case 26:
                  vm.ventasCategorias = false;
                  break;
                case 27:
                  vm.costeProductos = false;
                  break;
                case 28:
                  vm.gastosCasas = false;
                  break;
                case 29:
                  vm.gastoCasas = false;
                  break;
                case 30:
                  vm.gastosProveedoresUnidos = false;
                  break;
                case 31:
                  vm.gastosProveedor = false;
                  break;
                case 32:
                  vm.gastosEtiquetas = false;
                  break;
                case 33:
                  vm.gastosMateriaPrima = false;
                  break;
                case 34:
                  vm.ventasNegocio = false;
                  break;
                case 35:
                  vm.ventasComensales = false;
                  break;
                case 36:
                  vm.facturasSimplificadas = false;
                  break;
                case 37:
                  vm.facturasNominativas = false;
                  break;
                case 38:
                  vm.formasPago = false;
                  break;
                case 39:
                  vm.agencias = false;
                  break;
                case 40:
                  vm.cuentasAparcadas = false;
                  break;
                case 41:
                  vm.cierreCajas = false;
                  break;
                case 42:
                  vm.ventasClientes = false;
                  break;
                case 43:
                  vm.ventasOperarios = false;
                  break;
                case 44:
                  vm.turnosOperarios = false;
                  break;

                case 45:
                  vm.historicoDeProductos = false;
                  break;

                case 47:
                  vm.ventasAnuladas = false;
                  vm.ventasRectificadas = false;
                  break;

                case 48:
                  vm.rangoHorarios = false;
                  break;

                case 49:
                  vm.tieneSage = false;
                  break;

                case 50:
                  vm.aperturasOperarios=false;
                  break;

                case 74:
                  vm.pedidosRepartidores = false;
                  break;
                case 76:
                  vm.pedidosVentasProductos = false;
                  break;
                case 77:
                  vm.pedidosInforme = false;
                  break;
                case 78:
                  vm.pedidosPasarelaPago = false;
                  break;
              }
            }

            if (
              !vm.ventasProductos &&
              !vm.costeProductos &&
              !vm.historicoDeProductos &&
              !vm.ventasTotalProductos &&
              !vm.ventasCategorias &&
              !vm.invitaciones
            ) {
              vm.grupoProducto = false;
            }

            if (
              !vm.ventasNegocio &&
              !vm.rangoHorarios &&
              !vm.ventasComensales &&
              !vm.facturasSimplificadas &&
              !vm.facturasNominativas &&
              !vm.formasPago &&
              !vm.agencias &&
              !vm.cuentasAparcadas &&
              !vm.cierreCajas &&
              !vm.ventasAnuladas &&
              !vm.ventasRectificadas
            ) {
              vm.grupoVentas = false;
            }

            if ( 
              !vm.pedidosRepartidores &&
              !vm.pedidosVentasProductos &&
              !vm.pedidosInforme &&
              !vm.pedidosPasarelaPago
            ) {
              vm.grupoPedidos = false;
            }

            if (
              !vm.gastosProveedor &&
              !vm.gastosProveedoresUnidos &&
              !vm.gastosEtiquetas
            ) {
              vm.grupoProveedores = false;
            }

            if (!vm.gastosCasas && !vm.gastoCasas) {
              vm.grupoCasa = false;
            }

            if (!vm.ventasOperarios && !vm.turnosOperarios && !vm.aperturasOperarios) {
              vm.grupoOperario = false;
            }

            if (vm.ventasClientes) {
              vm.getTpv();
            }
          }
        })
        .catch(function (error) {
          console.log(error);
        });

      /*   this.axios.get(this.$store.getters.apiUrl + "general/getUser", config)
                    .then(function (response) {

                        if (response.data.response) {

                            vm.registrosHorarios = true;

                        } else {

                            vm.registrosHorarios = false;
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    });*/
    },
  },
};
</script>
<style scoped>
h3 {
  margin: 10px 0;
  color: #1E22AA;
  font-family: "Roboto", "Helvetica Neue", Arial, sans-serif;
}

h2 {
  margin: 10px 5px;
  font-family: "Numier", "Helvetica Neue", Arial;
  font-weight: bold;
  color: #1E22AA;
  font-size: 25px;
}

i {
  font-size: 20px;
}

.list-files {
  padding: 0;
  margin-bottom: 0px;
}

.list-files a:first-child li {
  border-top: none;
}

.list-files a li {
  list-style: none;
  padding: 15px 20px;
  font-size: 1.1em;
  border-top: 1px solid #bbb;
  /*font-weight: bold;*/
  color: #252422;
}

.list-files a li span {
  font-size: 0.7em;
}

.list-files p {
  margin: 0;
}

.list-files a li:hover {
  cursor: pointer;
  background-color: rgba(0, 153, 130, 0.2);
}

.content-card {
  border-top: 2px solid #00A3AD;
  padding: 0;
}

.prox {
  font-weight: 400;
  font-size: 0.8em;
}
</style>



// WEBPACK FOOTER //
// src/pages/Dashboard/Informes/Informes.vue